import Phaser from 'phaser';
import gameData from '../gameData';
import IntroScreenBase from './IntroScreenBase';
import ABCyaLib from '@abcya/abcya_lib';
import ABCyaPhaser from '@abcya/abcya_phaser';
import FontKeys from '../FontKeys';

export default class IntroMultiplesScreen extends IntroScreenBase {
  create() {
    if (gameData.gameMode === null) {
      gameData.gameMode = Phaser.Math.Between(2,12);
    }
    this.displayNum = gameData.gameMode;

    super.create();

    this.swipe.y = 280;
    this.objectDisplay.y = this.swipe.y + this.swipe.height / 2 + 26;
    this.pointerHand.y = this.swipe.y;

    this.lblInstructions.text = ABCyaLib.Environment.instance.gameConfig.introInstructionsText;
    this.lblInstructions.setLineSpacing(-40);
    this.lblInstructions.y = 165;

    this.hintText = ABCyaPhaser.Text.addText(this.scale.width / 2,this.scale.height - 50,'34pt', gameData.fontColor, FontKeys._cf_samurai_bobregular, '', this, true).setOrigin(0.5)
      .setLineSpacing(-20);

    switch (gameData.gameMode) {
      case 2:
        this.hintText.text = 'HINT: CHECK IF THE NUMBER IS EVEN.';
        break;
      case 3:
        this.hintText.text = 'HINT: ADD UP THE DIGITS AND CHECK\nIF THE SUM IS A MULTIPLE OF 3.';
        break;
      case 4:
        this.hintText.text = 'HINT: CHECK IF THE LAST TWO\nDIGITS MAKE A MULTIPLE OF 4.';
        break;
      case 5:
        this.hintText.text = 'HINT: CHECK IF THE NUMBER ENDS IN 0 OR 5.';
        break;
      case 6:
        this.hintText.text = 'HINT: CHECK IF THE NUMBER IS\nDIVISIBLE BY BOTH 2 AND 3.';
        break;
      case 9:
        this.hintText.text = 'HINT: ADD UP THE DIGITS AND CHECK\nIF THE SUM IS A MULTIPLE OF 9.';
        break;
      case 10:
        this.hintText.text = 'HINT: CHECK IF THE NUMBER ENDS IN 0.';
        break;
    }
  }

  goAway() {
    super.goAway([this.hintText]);
  }
}